import { configure, default as SentryFetch } from "@amzn/sentry-fetch";

/**
 * In E2E there's no interactive Midway session, so sentry-fetch's session
 * probe 401s despite valid backend auth; we skip the probe there.
 */
const isCypressTestRun = (): boolean =>
  typeof window !== "undefined" && Boolean((window as Window & { Cypress?: unknown }).Cypress);

/** Wraps sentry-fetch so API requests carry Midway authentication. */
export class BaseService {
  protected sentryFetch: typeof SentryFetch;
  protected baseUrl: string;

  constructor(baseUrl: string) {
    this.sentryFetch = configure({
      debug: false,
      followMidwayStepUp: true,
      failOnInvalidSession: true,
      skipMidwaySessionCheck: isCypressTestRun(),
    });
    this.baseUrl = baseUrl;
  }

  public async fetch(fullPath: string, init?: RequestInit): Promise<Response> {
    const normalizedPath = fullPath.startsWith("/") ? fullPath : `/${fullPath}`;
    const url = `${this.baseUrl}${normalizedPath}`;
    const requestInit: RequestInit = {
      credentials: "include",
      mode: "cors",
      ...init,
    };

    return await this.sentryFetch(url, requestInit);
  }
}
